export function parseTrmRiskMatrix(content: string): Record<string, unknown>[] | null {
    try {
        const parsed = JSON.parse(content.trim().replace(/^```(?:json)?\s*([\s\S]*?)\s*```$/i, '$1'));
        const rows = Array.isArray(parsed) ? parsed : parsed?.perLegRiskMatrix;
        return Array.isArray(rows) && rows.every(row => row && typeof row === 'object' && !Array.isArray(row)) ? rows : null;
    } catch {
        return null;
    }
}

export const trmRiskMatrixLabel = (key: string) => key.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ').replace(/^./, character => character.toUpperCase());
